// getBrandsByIds returns the brands for the given Ids
export const BrandV1_getBrandsByIdsLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_getBrandsByIds);
BrandV1_getBrandsByIdsLazy.method = "brands.BrandV1/getBrandsByIds" as const;

// getBrandsBySlugs finds the brands for the given slugs
export const BrandV1_getBrandsBySlugsLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_getBrandsBySlugs);
BrandV1_getBrandsBySlugsLazy.method =
  "brands.BrandV1/getBrandsBySlugs" as const;

// getPrimaryBrandStories returns the primary brand story for the requested gender
export const BrandV1_getPrimaryBrandStoriesLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_getPrimaryBrandStories);
BrandV1_getPrimaryBrandStoriesLazy.method =
  "brands.BrandV1/getPrimaryBrandStories" as const;

// getSubCategories returns the sub categories for the requested brands
export const BrandV1_getSubCategoriesLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_getSubCategories);
BrandV1_getSubCategoriesLazy.method =
  "brands.BrandV1/getSubCategories" as const;

// likeBrand likes a specific brand for the current customer
export const BrandV1_likeBrandLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_likeBrand);
BrandV1_likeBrandLazy.method = "brands.BrandV1/likeBrand" as const;

// unlikeBrand unlikes a specific brand for the current customer
export const BrandV1_unlikeBrandLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_unlikeBrand);
BrandV1_unlikeBrandLazy.method = "brands.BrandV1/unlikeBrand" as const;

// dislikeBrand dislikes a specific brand for the current customer
export const BrandV1_dislikeBrandLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_dislikeBrand);
BrandV1_dislikeBrandLazy.method = "brands.BrandV1/dislikeBrand" as const;

// getBrandCluster returns the entire brand cluster including top categories with sub categories
// and the main story for each brand and gender
export const BrandV1_getBrandClusterLazy = () =>
  import("./brand_v1.grpc").then((m) => m.BrandV1_getBrandCluster);
BrandV1_getBrandClusterLazy.method = "brands.BrandV1/getBrandCluster" as const;
